import { Box, Typography } from "@mui/material";

export const MetricItem = ({ icon, label, value, containerSx, valueSx }) => {
  return (
    <Box
      className="metrics-container"
      sx={{
        ...containerSx,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          component="img"
          src={icon}
          alt={`${label} Icon`}
          className="cohort-metric-icon"
        />
        <Typography className="cohort-metric-label">{label}</Typography>
      </Box>
      <Typography
        className="cohort-drawer-metric-range"
        sx={{
          ...valueSx,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};
